import React from 'react';

export const ScriptContent = () => (
  <>
    <h3>New Quote - Terms and Conditions</h3>
    <p>
      Before we continue I need to make you aware that you are under a duty to
      answer all the questions that will be asked, honestly and with reasonable
      care and attention. These questions are material in determining if the
      policy underwriter can accept this risk, what terms are applied and what
      premium is charged. If you do not answer these questions honestly and with
      reasonable care and attention, the policy underwriter may use the remedies
      available to them under the consumer Insurance Contracts Act 2019 (and any
      subsequent amending legislation) including the remedy to cancel the
      contract, reject a claim or to limit the amount they pay in the event of a
      claim.
    </p>
    <p>
      By continuing you are agreeing to our Terms and Conditions, Commission Summary Document, Terms of Use,
      Accessibility Statement and Data Privacy Notice which are available on the Bank of Ireland website, attached to
      any quote generated or with your policy documents. Do you understand your duty and are you happy to proceed?
    </p>
    <p>Can you confirm that you are authorised to speak on behalf of XXXXX?</p>
    <br />

    <h3>Data Security</h3>
    <p>Please confirm security questions are completed</p>
  </>
);
